import { Flex, FlexProps } from "styled-system/jsx";
import { Text, TextProps } from "@ttc3k/trekker";
import { WhereaboutsLogo } from "shared/components";
import { useTranslation } from "react-i18next";

type PoweredByWhereaboutsProps = {
  containerProps?: FlexProps;
  textProps?: TextProps;
  /** Width of the Whereabouts logo in px. Defaults to 121. */
  logoWidth?: number;
};

export const PoweredByWhereabouts = ({
  containerProps,
  textProps,
  logoWidth = 121,
}: PoweredByWhereaboutsProps) => {
  const { t } = useTranslation();
  return (
    <Flex
      gap={"75"}
      alignItems={{ base: "flex-start", md: "center" }}
      flexDir={{ base: "column", md: "row" }}
      {...containerProps}
    >
      <Text visual={"smallRegular"} color={"text.light"} {...textProps}>
        {t("core:POWERED_BY")}
      </Text>
      <WhereaboutsLogo width={logoWidth} height="auto" />
    </Flex>
  );
};
